var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 9.5C0 4.254 4.254 0 9.5 0h5a9.5 9.5 0 0 1 0 19h-.197l-5.748 3.832A1 1 0 0 1 7 22v-3.34C2.968 17.56 0 13.882 0 9.5M9.5 2A7.5 7.5 0 0 0 2 9.5c0 3.687 2.665 6.749 6.176 7.376A1 1 0 0 1 9 17.86v2.271l4.445-2.963A1 1 0 0 1 14 17h.5a7.5 7.5 0 0 0 0-15z",
    clipRule: "evenodd"
  })));
};
export default SvgChat;